// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7d16b34f","455":"2d4eebf2","977":"58619cfc"}[chunkId] + ".chunk.js";
};